<template>
  <v-container>
    <v-text-field
      prefix="Nombre:"
      class="ml-3 mr-3"
      v-model="selectedItem.settings.component_name"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.settings.component_name == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
      @blur="updateEditing(false)"
    />

    <v-text-field
      prefix="Topic lectura:"
      class="ml-3 mr-3"
      v-model="readTopic"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.topic_read == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
      @blur="updateEditing(false)"
    />

    <v-text-field
      prefix="Topic escritura:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.topic_write"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.topic_write == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
      @blur="updateEditing(false)"
    />

    <v-text-field
      prefix="IP:"
      class="ml-3 mr-3"
      v-model="selectedItem.customized.ip"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.customized.ip == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
      @blur="updateEditing(false)"
    />

    <v-text-field
      prefix="Puerto:"
      class="ml-3 mr-3"
      v-model.number="selectedItem.customized.port"
      single-line
      type="number"
      @keypress="validatePort($event)"
      :min="0"
      :max="65535"
      @keyup.enter="updateEditing(false)"
      @click="updateEditing(true)"
      @blur="updateEditing(false)"
    />

    <v-text-field
      prefix="Nº max. variables:"
      class="ml-3 mr-3"
      v-model.number="selectedItem.customized.count"
      single-line
      type="number"
      @keypress="validateCount($event)"
      :min="0"
      :max="999"
      @keyup.enter="updateEditing(false)"
      @click="updateEditing(true)"
      @blur="updateEditing(false)"
    />

    <div v-if="!atLeastOneVariable">
      <h4 class="text-center mt-3">Añadir variables:</h4>
      <v-file-input
        class="ml-3 mr-3"
        accept=".xlsx"
        label="Seleccionar Excel"
        show-size
        v-model="file"
        @change="onFileChange()"
      >
      </v-file-input>
    </div>

    <div
      v-else
      class="text-center dialog"
    >
      <v-dialog
        scrollable
        v-if="atLeastOneVariable"
        v-model="dialog"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="btn mt-4"
            rounded
            color="black"
            dark
            v-bind="attrs"
            v-on="on"
            @click="dialog = true"
          >
            Ver variables ({{ selectedItem.customized.vartable.length }})
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            Variables - {{ selectedItem.settings.component_name }} <v-spacer> </v-spacer>
            <v-icon @click="dialog = false">mdi-close</v-icon>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items-per-page="-1"
              hide-default-footer
              disable-pagination
              :items="selectedItem.customized.vartable"
              class="elevation-1 mt-10 ml-10 mr-10 mb-10"
            >
              <template v-slot:[`item.value`]="props">
                <v-edit-dialog
                  v-if="props.item.action == 'W'"
                  :return-value.sync="props.item.value"
                  @save="save(props.item)"
                >
                  {{ props.item.value }}
                  <template v-slot:input>
                    <v-text-field
                      v-model="props.item.value"
                      label="Edit"
                      single-line
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
                <template v-else>
                  {{ props.item.value }}
                </template>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <div class="mt-5 text-center">
      <v-btn
        v-if="atLeastOneVariable && selectedItem.customized.vartable.length > 0"
        text
        @click="atLeastOneVariable = false"
      >
        Modificar variables
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import readXlsFile from "read-excel-file";
import { debounce } from "lodash";

import { mapActions, mapState } from "vuex";

export default {
  name: "KoioteOmronConnectionProperties",

  data() {
    return {
      file: [],
      readtopic: "",
      oldReadTopic: "",
      modifying: false,
      dialog: false,
      atLeastOneVariable: false,
      headers: [
        { text: "Variable", value: "address" },
        { text: "Variable formateada", value: "formatted_address" },
        { text: "Descripción", value: "description" },
        { text: "Tipo", value: "type" },
        { text: "Historización (s)", value: "seconds" },
        { text: "Valor actual", value: "value" },
      ],
    };
  },
  computed: {
    ...mapState(["selectedItem"]),
    ...mapState("nodered", ["client"]),
  },

  methods: {
    ...mapActions(["updateEditing", "updateSelectedItem"]),
    ...mapActions("nodered", ["doSubscribe", "doUnsubscribe", "doPublish"]),

    checkIP() {
      return /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/gi.test(
        this.selectedItem.customized.ip
      );
    },

    validatePort($event) {
      if (this.isNumber($event)) {
        if (this.selectedItem.customized.port * 10 + parseInt($event.key) > 65535) $event.preventDefault();
      }
    },

    validateCount($event) {
      if (this.isNumber($event)) {
        if (this.selectedItem.customized.count * 10 + parseInt($event.key) > 999) $event.preventDefault();
      }
    },

    isNumber($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
        return false;
      } else {
        return true;
      }
    },

    async onFileChange() {
      if (this.file) {
        this.selectedItem.customized.vartable = [];
        const rows = await readXlsFile(this.file);
        if (rows.length <= 0) return;
        const rowsWithoutBlanks = rows.filter((e) => e[0] != null && e[1] != null);

        rowsWithoutBlanks.forEach((e) => {
          this.selectedItem.customized.vartable.push({
            address: e[0],
            formatted_address: e[1],
            description: e[2] || "-",
            type: e[3].toUpperCase(),
            seconds: e[4] || null,
            action: e[5] === "W" ? "W" : "R",
            scale: e[6] != null ? e[6] : 1,
            decimals: e[7] != null ? e[7] : 2,
            alarm: e[8] != null,
            alarm_value: e[8] != null && e[9] != "false",
            value: "",
          });
        });

        this.updateSelectedItem(this.selectedItem);
        this.atLeastOneVariable = this.selectedItem.customized.vartable.length > 0;
        this.file = [];
      }
    },

    save(item) {
      const readValue = (() => {
        switch (item.type) {
          case "BIT":
            return item.value === "true";
          case "ENTERO":
          case "REAL":
            return Number(item.value);
          default:
            return "";
        }
      })();
      this.doPublish({
        topic: this.selectedItem.customized.topic_write,
        message: { address: item.address, value: readValue },
      });
    },
  },

  created() {
    this.atLeastOneVariable = this.selectedItem.customized.vartable.length > 0;
    this.readTopic = this.selectedItem.customized.topic_read;
    this.oldReadTopic = this.selectedItem.customized.topic_read;
  },

  watch: {
    readTopic: {
      handler: debounce(function () {
        if (this.readTopic.length > 0 && this.readTopic !== this.oldReadTopic) {
          this.doSubscribe(this.readTopic);
          this.selectedItem.customized.topic_read = this.readTopic;
          this.doUnsubscribe(this.oldReadTopic);
          this.oldReadTopic = this.readTopic;
        }
      }, 1000),
      deep: true,
    },
  },
};
</script>

<style>
.dialog {
  z-index: 9000;
}
.v-data-table tbody tr:hover:not(.v-data-table__expanded__content) {
  background: #ffffff !important;
}
</style>
